import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LessonForm from "../../components/forms/LessonForm";
import BasePage from "../common/BasePage";
import { useTranslation } from "react-i18next";

type Params = {
  learningPathId: string;
};

export default function NewLessonPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const { learningPathId } = useParams<Params>();
  const onSuccess = useCallback(
    (createdLessonId: number) => {
      navigate(`../${createdLessonId}`);
      toast({
        title: t("new_lesson_page.lesson_created"),
        description: t("new_lesson_page.lesson_created_message"),
        status: "success",
        isClosable: true,
      });
    },
    [navigate, t, toast],
  );

  const onError = useCallback(() => {
    toast({
      title: t("new_lesson_page.lesson_error"),
      description: t("new_lesson_page.lesson_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage title={t("new_lesson_page.new_lesson")}>
      <LessonForm
        learningPathId={learningPathId}
        onSuccess={onSuccess}
        onError={onError}
      />
    </BasePage>
  );
}
